module.exports = __webpack_public_path__ + "static/media/celery.a039e8ef.svg";